import React, { useState, useEffect } from 'react';
import axiosConfig from "../../api/axiosConfig"; // Kendi import yolunuza göre güncelleyebilirsiniz

const LessonGroupManagementPage = () => {

  const [lessonGroups, setLessonGroups] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [currentLessonGroup, setCurrentLessonGroup] = useState(null);
  const [formData, setFormData] = useState({
    ders_adi: '',
  });

  const [searchTerm, setSearchTerm] = useState('');

  // updated_at filtre: "all", "updated", "not-updated"
  const [filterType, setFilterType] = useState('all');

  // Tarih aralığı filtre (created_at)
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // Toplu silme seçili ID'ler
  const [selectedIds, setSelectedIds] = useState([]);

  // Sayfa yüklendiğinde verileri çek
  useEffect(() => {
    fetchLessonGroups();
  }, []);

  // Ders grubu listesini sunucudan çek
  const fetchLessonGroups = async () => {
    try {
      const response = await axiosConfig.get('/admin/dersgrubu');
      setLessonGroups(response.data);
      setSelectedIds([]);
    } catch (error) {
      console.error('Lesson groups fetch error:', error);
    }
  };

  // Yeni ders grubu eklemek için formu aç
  const openFormForCreate = () => {
    setCurrentLessonGroup(null);
    setFormData({ ders_adi: '' });
    setIsFormOpen(true);
  };

  // Mevcut bir ders grubunu düzenlemek için formu aç
  const openFormForEdit = (lessonGroup) => {
    setCurrentLessonGroup(lessonGroup);
    setFormData({
      ders_adi: lessonGroup.ders_adi,
    });
    setIsFormOpen(true);
  };

  // Formu kapat (modal)
  const closeForm = () => {
    setIsFormOpen(false);
    setCurrentLessonGroup(null);
    setFormData({ ders_adi: '' });
  };

  // Ekleme/Güncelleme form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (currentLessonGroup) {
        // Güncelle
        await axiosConfig.put(`/admin/dersgrubu/${currentLessonGroup.id}`, {
          ders_adi: formData.ders_adi,
        });
      } else {
        // Ekle
        await axiosConfig.post('/admin/dersgrubu', {
          ders_adi: formData.ders_adi,
        });
      }
      fetchLessonGroups();
      closeForm();
    } catch (error) {
      console.error('handleSubmit error:', error);
    }
  };

  // Tekil silme
  const handleDelete = async (id) => {
    if (!window.confirm('Bu ders grubunu silmek istediğinizden emin misiniz?')) return;
    try {
      await axiosConfig.delete(`/admin/dersgrubu/${id}`);
      fetchLessonGroups();
    } catch (error) {
      console.error('handleDelete error:', error);
    }
  };

  // Toplu silme
  const handleBatchDelete = async () => {
    if (selectedIds.length === 0) return;
    if (!window.confirm('Seçili ders gruplarını silmek istediğinizden emin misiniz?')) return;

    try {
      for (const id of selectedIds) {
        await axiosConfig.delete(`/admin/dersgrubu/${id}`);
      }
      fetchLessonGroups();
    } catch (error) {
      console.error('Batch delete error:', error);
    }
  };

  // Checkbox değişimi (tek satır)
  const handleSelectChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((selId) => selId !== id) : [...prev, id]
    );
  };

  // Tüm checkbox'ları seç / kaldır
  const handleSelectAll = () => {
    if (selectedIds.length === lessonGroups.length) {
      setSelectedIds([]);
    } else {
      const allIds = lessonGroups.map((lg) => lg.id);
      setSelectedIds(allIds);
    }
  };

  // Arama metni değişimi
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Updated / Not-Updated filtre değişimi
  const handleFilterChange = (e) => {
    setFilterType(e.target.value);
  };

  // Tarih aralığı filtre değişimi
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };
  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  // Filtrelenmiş ders grubu listesi
  const filteredLessonGroups = lessonGroups.filter((lg) => {
    // 1) Arama (ders_adi)
    const matchesSearch = lg.ders_adi
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    // 2) updated_at filtre
    let matchesFilter = true;
    if (filterType === 'updated') {
      matchesFilter = !!lg.updated_at;
    } else if (filterType === 'not-updated') {
      matchesFilter = !lg.updated_at;
    }

    // 3) created_at tarih aralığı
    let matchesDateRange = true;
    if (startDate) {
      const cDate = new Date(lg.created_at);
      const sDate = new Date(startDate);
      if (cDate < sDate) {
        matchesDateRange = false;
      }
    }
    if (endDate) {
      const cDate = new Date(lg.created_at);
      const eDate = new Date(endDate);
      if (cDate > eDate) {
        matchesDateRange = false;
      }
    }

    return matchesSearch && matchesFilter && matchesDateRange;
  });

  // "Tümü seçili mi" kontrolü
  const allSelected =
    selectedIds.length === lessonGroups.length && lessonGroups.length > 0;

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-7xl mx-auto bg-white p-6 rounded-md shadow-md">
        {/* Üst kısım */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
          <h2 className="text-2xl font-bold text-gray-700">Ders Grubu Listesi</h2>
          <div className="flex gap-2">
            <button
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={handleBatchDelete}
              disabled={selectedIds.length === 0}
            >
              Seçili Ders Gruplarını Sil
            </button>
            <button
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              onClick={openFormForCreate}
            >
              Yeni Ders Grubu Ekle
            </button>
          </div>
        </div>

        {/* Arama ve filtreleme */}
        <div className="flex flex-col md:flex-row md:flex-wrap gap-4 mb-4">
          {/* Arama */}
          <div>
            <label htmlFor="searchInput" className="block text-gray-700 font-medium mb-1">
              Ders Ara
            </label>
            <input
              id="searchInput"
              type="text"
              className="border border-gray-300 rounded px-3 py-2 w-full md:w-56 focus:outline-none focus:ring-1 focus:ring-blue-500"
              placeholder="Ders adı yazın..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>

          {/* Updated / Not-Updated filtre */}
          <div>
            <label htmlFor="filterSelect" className="block text-gray-700 font-medium mb-1">
              Güncelleme Durumu
            </label>
            <select
              id="filterSelect"
              className="border border-gray-300 rounded px-3 py-2 w-full md:w-44 focus:outline-none focus:ring-1 focus:ring-blue-500"
              value={filterType}
              onChange={handleFilterChange}
            >
              <option value="all">Hepsi</option>
              <option value="updated">Güncellenmiş</option>
              <option value="not-updated">Güncellenmemiş</option>
            </select>
          </div>

          {/* Tarih Aralığı: Başlangıç */}
          <div>
            <label htmlFor="startDate" className="block text-gray-700 font-medium mb-1">
              Başlangıç Tarihi
            </label>
            <input
              id="startDate"
              type="date"
              className="border border-gray-300 rounded px-3 py-2 w-full md:w-44 focus:outline-none focus:ring-1 focus:ring-blue-500"
              value={startDate}
              onChange={handleStartDateChange}
            />
          </div>

          {/* Tarih Aralığı: Bitiş */}
          <div>
            <label htmlFor="endDate" className="block text-gray-700 font-medium mb-1">
              Bitiş Tarihi
            </label>
            <input
              id="endDate"
              type="date"
              className="border border-gray-300 rounded px-3 py-2 w-full md:w-44 focus:outline-none focus:ring-1 focus:ring-blue-500"
              value={endDate}
              onChange={handleEndDateChange}
            />
          </div>
        </div>

        {/* Ders Grubu Tablosu */}
        <div className="overflow-x-auto">
          <table className="w-full table-auto border-collapse">
            <thead>
              <tr className="bg-gray-200 text-gray-700">
                <th className="p-3 border border-gray-300 text-center">
                  <input
                    type="checkbox"
                    checked={allSelected}
                    onChange={handleSelectAll}
                  />
                </th>
                <th className="p-3 border border-gray-300 text-left">ID</th>
                <th className="p-3 border border-gray-300 text-left">Ders Adı</th>
                <th className="p-3 border border-gray-300 text-left">Oluşturulma</th>
                <th className="p-3 border border-gray-300 text-left">Güncellenme</th>
                <th className="p-3 border border-gray-300 text-left">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {filteredLessonGroups.map((lg) => {
                const isSelected = selectedIds.includes(lg.id);
                return (
                  <tr key={lg.id} className="hover:bg-gray-100">
                    <td className="p-3 border border-gray-200 text-center">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => handleSelectChange(lg.id)}
                      />
                    </td>
                    <td className="p-3 border border-gray-200">{lg.id}</td>
                    <td className="p-3 border border-gray-200">{lg.ders_adi}</td>
                    <td className="p-3 border border-gray-200">
                      {lg.created_at ? new Date(lg.created_at).toLocaleString() : '-'}
                    </td>
                    <td className="p-3 border border-gray-200">
                      {lg.updated_at ? new Date(lg.updated_at).toLocaleString() : '-'}
                    </td>
                    <td className="p-3 border border-gray-200">
                      <button
                        className="bg-blue-500 text-white px-3 py-1 rounded mr-2 hover:bg-blue-600"
                        onClick={() => openFormForEdit(lg)}
                      >
                        Düzenle
                      </button>
                      <button
                        className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                        onClick={() => handleDelete(lg.id)}
                      >
                        Sil
                      </button>
                    </td>
                  </tr>
                );
              })}
              {filteredLessonGroups.length === 0 && (
                <tr>
                  <td colSpan="6" className="p-4 text-center text-gray-500">
                    Kayıt bulunamadı.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Form Modal */}
      {isFormOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-md shadow-md w-full max-w-md">
            <h3 className="text-xl font-semibold mb-4 text-gray-700">
              {currentLessonGroup ? 'Ders Grubunu Düzenle' : 'Yeni Ders Grubu Ekle'}
            </h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label
                  htmlFor="ders_adi"
                  className="block mb-1 font-medium text-gray-600"
                >
                  Ders Adı
                </label>
                <input
                  id="ders_adi"
                  name="ders_adi"
                  className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  value={formData.ders_adi}
                  onChange={(e) =>
                    setFormData({ ...formData, ders_adi: e.target.value })
                  }
                  required
                />
              </div>
              <div className="flex justify-end space-x-2">
                <button
                  type="button"
                  className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
                  onClick={closeForm}
                >
                  İptal
                </button>
                <button
                  type="submit"
                  className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                >
                  {currentLessonGroup ? 'Güncelle' : 'Kaydet'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default LessonGroupManagementPage;
